import { useCallback } from "react";

export function useConversationHistory(API_URL) {
  const fetchConversationHistory = useCallback(
    async (userId, conversationId) => {
      if (!API_URL || !userId || !conversationId) return [];
      try {
        const res = await fetch(
          `${API_URL}/chat_history?conversation_id=${encodeURIComponent(conversationId)}`,
          { credentials: "include" }
        );
        if (!res.ok) {
          console.error("Failed to fetch conversation history", res.status);
          return [];
        }
        const json = await res.json();
        if (json.status !== "ok" || !Array.isArray(json.chat_history)) {
          return [];
        }
        return json.chat_history;
      } catch (e) {
        console.error("Error fetching conversation history", e);
        return [];
      }
    },
    [API_URL]
  );

  return { fetchConversationHistory };
}
